import React from "react";

interface TabSectionHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const TabSectionHeader: React.FC<TabSectionHeaderProps> = ({
  title,
  description,
  action,
}) => (
  <div className="flex flex-wrap items-start justify-between gap-3">
    <div>
      <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
      {description && (
        <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>
      )}
    </div>
    {action && <div className="flex shrink-0 items-center gap-2">{action}</div>}
  </div>
);

export default TabSectionHeader;
